import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router';
import { StoreState } from '@ui/store/rootReducer';
import { LoadableContent } from '@ui/components';
import { regionsSelectors } from '../';
import * as actions from '../services/actions';
import RegionsList from '../components/RegionsList';

import './regions.less';

interface StateToProps {
  loading: boolean;
  regions: any[];
}

interface DispatchToProps {
  onLoadCountries: () => void;
}

type Props = StateToProps & DispatchToProps & RouteComponentProps;

class Regions extends React.PureComponent<Props> {
  componentDidMount(): void {
    const { onLoadCountries } = this.props;
    onLoadCountries();
  }

  handleClickCountry = (region: any) => {
    const { history } = this.props;
    history.push(`region/${region.id}`);
  };

  render(): React.ReactNode {
    const { loading, regions } = this.props;
    return (
      <LoadableContent loading={loading}>
        <div className="regions-page__content">
          <RegionsList regions={regions} onClick={this.handleClickCountry} />
        </div>
      </LoadableContent>
    );
  }
}

const mapStateToProps = (state: StoreState): StateToProps => ({
  regions: regionsSelectors.getRegions(state),
  loading: regionsSelectors.getLoading(state),
});

const mapDispatchToProps = {
  onLoadCountries: actions.regionsRequested,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Regions),
);



// WEBPACK FOOTER //
// ./src/scenes/Regions/containers/Regions.tsx